import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { GroupListItemDataFragment, SubgroupListItemDataFragment } from '../GroupListing/GroupList.api';

interface ViewCourseProps {
    group?: GroupListItemDataFragment;
    subgroup?: SubgroupListItemDataFragment;
}

const ViewCourse = ({ group, subgroup }: ViewCourseProps) => {
    const { t } = useTranslation('groupDetails');

    const coursesOptions = useMemo(() => {
        const coursesOptions = (group?.enrolledCourses || []).map(course => ({
            value: course.id,
            label: course.name,
        }));

        return coursesOptions;
    }, [group?.enrolledCourses]);

    return (
        <div>
            <div className="space-y-2">
                <span className="block text-left text-sm leading-6 font-medium text-black capitalize dark:text-white">
                    {subgroup
                        ? t('fields.courses.titleSubgroup', { parentGroupName: group?.name })
                        : t('fields.courses.titleGroup')}
                </span>
                <div className="rounded-md border border-gray-300 bg-gray-50 p-4">
                    {coursesOptions.length > 0 ? (
                        <div className="flex flex-wrap gap-2">
                            {coursesOptions.map(course => (
                                <span
                                    key={course.value}
                                    className="inline-flex items-center rounded-full bg-gray-200 px-3 py-1 text-xs font-medium text-gray-800 dark:bg-gray-700 dark:text-gray-100"
                                >
                                    {course.label}
                                </span>
                            ))}
                        </div>
                    ) : (
                        <p className="text-sm text-gray-500">{t('fields.courses.error')}</p>
                    )}
                    {subgroup && <p className="mt-2 text-xs text-gray-500 italic">{t('fields.courses.footer')}</p>}
                </div>
            </div>
        </div>
    );
};

export default ViewCourse;
